import React from 'react'; 

const Organizer = () => {
    return (
        <div>
        <p>Page under construction</p>
        <p>Coming soon!</p>
        </div>
    );   
}

export default Organizer; 